import Vue from 'vue'
import VueI18n from 'vue-i18n'
import App from './app/Main.vue'
import router from './router'
import store from './vuex'
import VeeValidate from 'vee-validate'
import VeeValidateMessagesBR from 'vee-validate/dist/locale/pt_BR'
import * as types from './app/pages/auth/vuex/mutations-types'
import FlashMessage from 'src/app/components/shareds/flash/FlashMessage'
import axios from 'axios'
import Locales from './lang/parser'
import Lang from 'src/utils/lang'
import Validators from 'src/utils/validators'
// import Rollbar from 'vue-rollbar'
import Loader from './plugins/loader'
import ModalLoader from './plugins/modal-loader'
import vSelect from 'vue-select'
import AwesomeMask from 'awesome-mask'
import Paginate from 'vuejs-paginate'
import AdminLayout from './app/layouts/admin.vue'
import SubscribeLayout from './app/layouts/subscribe.vue'
import 'locawebstyle/dist/stylesheets/locastyle.css'
import 'font-awesome/css/font-awesome.css'
import 'vue2-animate/dist/vue2-animate.min.css'
import 'src/assets/icons/style.css'
import 'src/assets/custom/recurrence.css'
import AuthorizedLink from 'src/app/components/shareds/authorized-link/AuthorizedLink'

Vue.use(Loader, store)
Vue.use(ModalLoader, store)
Vue.use(VeeValidate, {locale: 'pt_BR'})
VeeValidate.Validator.localize('pt-BR', VeeValidateMessagesBR)
Vue.use(VueI18n)

if (process.env.NODE_ENV === 'production') {
  /*
  Vue.use(Rollbar, {
    accessToken: process.env.ROLLBAR_TOKEN,
    captureUncaught: true,
    captureUnhandledRejections: true,
    payload: {
      environment: 'production'
    }
  })
  */
}

Vue.directive('mask', AwesomeMask)

// I18n configs
Vue.config.lang = 'pt-BR'
Vue.locale('pt-BR', Locales.ptBR)

Vue.component('paginate', Paginate)
Vue.component('v-select', vSelect)
Vue.component('flash-message', FlashMessage)
Vue.component('admin-layout', AdminLayout)
Vue.component('authorized-link', AuthorizedLink)
Vue.component('subscribe-layout', SubscribeLayout)

var tkn = window.localStorage.getItem('userToken')
var usr = window.localStorage.getItem('user')
var adm = window.localStorage.getItem('admUser')
var logged = window.localStorage.getItem('isLogged')

if (logged === 'true') {
  store.commit(types.setIsLogged, true)
} else {
  store.commit(types.setIsLogged, false)
}

if (tkn && (usr || adm)) {
  store.commit(types.setUserToken, tkn)

  try {
    if (adm) {
      store.commit(types.setAdmUser, JSON.parse(adm))
    } else {
      store.commit(types.setUser, JSON.parse(usr))
    }
  } catch (e) {
    console.info('Recurrence: Falha tratada em converter user ou admUser em JSON - ' + e)
  }
}

axios.defaults.headers.common['Accept'] = 'application/json'

Vue.use({
  install (V) {
    let helper = new Vue()
    V.prototype.$helper = helper
    V.helper = helper
  }
})

/* eslint-disable no-new */
new Vue({
  router,
  store,
  el: '#app',
  template: '<App/>',
  components: { App },
  methods: {
    plural: Lang.plural
  },
  mounted () {
    var validations = Validators.validations(this)
    for (var key in validations) {
      this.$validator.extend(key, validations[key])
    }
  }
})



// WEBPACK FOOTER //
// ./src/main.js